import React from 'react'
import "./TeamCustomContent.css"
import { useNavigate } from 'react-router-dom'

function TeamCustomContent() {
    const navigate = useNavigate()
  return (
    <div className='TeamCustomContent-container standard-padding-space' >
        <div className='container mb-4'>
            <div className='text-start content-container'>

                <div className='d-flex gap-4 flex-lg-row flex-column-reverse mt-4'>
                    
                    <div>
                        <h3 className={`body-heading my-4 color-light`}> Meet the Strategist Behind Divitiis</h3>
                        <p className={`body-paragraph color-dark mb-0 pb-3 color-light`}>
                            I'm Betsy, founder and Creative Director of Divitiis-I believe that real marketing starts with real stories.
                        </p>
                        <p className={`body-paragraph color-dark mb-0 pb-3 color-light`}>
                           Since 2015, I've worked at the intersection of strategy, storytelling, and relationship- building in the wealth management industry-helping professionals build brands that feel human, trustworthy, and compelling.
                        </p>
                        <p className={`body-paragraph color-dark mb-0 pb-3 color-light`}>
                           I've led national campaigns, coached top performers, and shaped firm-wide ecosystems. But more than anything, I've helped people uncover what makes them different and use that as fuel to grow their business with clarity and confidence.
                        </p>
                        
                         <p className={`body-paragraph color-dark mb-0 pb-3 color-light`}>
                            Divitiis is the next evolution of that mission: a high-touch agency for professionals ready to lead with authenticity and boldness.
                            </p>
                            <p className={`body-paragraph color-dark mb-0 pb-3 color-light`}>
                            Let's build a brand that speaks your truth—and makes people listen.
                            </p>
                            <button className={`genral-btn btn-pink mt-3`} onClick={()=>{navigate("/contact")}}>  Book a Discovery Call</button>
                    </div>
                    <img src='/images/NewAssets/creatives/team-text-1.jpg' alt='content' className='img-fluid floatingImageProcesss ms-lg-3 ms-auto'  />

                </div>
               
            </div>
        </div>
    </div>
  )
}

export default TeamCustomContent